export enum BufferModes {
    POINT = 0,
    LINE,
    VERTICAL_LINE,
    CROSS_SECTION,
    BOX,
}

export type BufferModeType = (typeof BufferModes)[keyof typeof BufferModes];
